import { useState, useEffect } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { FiSearch, FiX } from "react-icons/fi";
import VehicleCard from "../VehicleCard";
import useFinanciaciones from "../../config/useFinanciaciones";
import loading from "../../assets/loading.svg";
import FinancingCarousel from "./FinancingCarousel";
import { buildRouteWithUtms } from "../../config/whatsappConfig";
import { handleStaticLandingCapture } from "../../utils/staticLandings";

const matchesModelSearch = (item, query) => {
  const term = query.trim().toLowerCase();
  if (!term) return true;
  const info = item.convencional;
  const modelo = (info?.modelo || "").toLowerCase();
  const version = (info?.version || "").toLowerCase();
  return modelo.includes(term) || version.includes(term);
};

const VehicleList = ({ vehicles }) => {
  const [modelSearch, setModelSearch] = useState("");

  const history = useHistory();
  const location = useLocation();
  const { tipo } = useParams();
  const { financiaciones, loading: loadingFinanciaciones } = useFinanciaciones();

  useEffect(() => {
    if (handleStaticLandingCapture(tipo, location.search)) return;
    if (tipo === "plan") {
      history.replace(buildRouteWithUtms("/convencional", location.search));
      return;
    }
    if (tipo !== "todos" && tipo !== "convencional" && tipo !== undefined) {
      history.push(buildRouteWithUtms("/todos", location.search));
    }
  }, []);

  const tipoSearch = tipo || "todos";

  const handleTipo = (targetTipo) => {
    history.push(buildRouteWithUtms(`/${targetTipo}`, location.search));
  };

  const filtradosConvencional = vehicles.filter((item) => item.convencional?.habilitado === true);
  const filteredConvencional = filtradosConvencional.filter((item) => matchesModelSearch(item, modelSearch));

  const isSearching = Boolean(modelSearch.trim());
  const noResults = isSearching && filteredConvencional.length === 0;

  return (
    <>
      <div id="scroll-click" className="vehicle-list-toolbar pt-4 pb-4">
        <div className="vehicle-list-toolbar-inner">
          <div className="vehicle-list-toolbar-buttons">
            <button
              type="button"
              className={`btn-toolbar-tab${tipoSearch === "convencional" || tipoSearch === "todos" ? " active" : ""}`}
              onClick={() => handleTipo("convencional")}
            >
              Venta directa
            </button>
          </div>
          <div className="vehicle-list-search">
            <FiSearch size={18} aria-hidden />
            <input
              type="search"
              placeholder="Buscar modelo..."
              value={modelSearch}
              onChange={(e) => setModelSearch(e.target.value)}
              aria-label="Buscar modelo"
            />
            {modelSearch ? (
              <button
                type="button"
                className="vehicle-list-search-clear"
                onClick={() => setModelSearch("")}
                aria-label="Limpiar búsqueda"
              >
                <FiX size={18} />
              </button>
            ) : null}
          </div>
        </div>
      </div>

      {noResults ? (
        <p className="vehicle-list-no-results">No encontramos resultados para tu búsqueda.</p>
      ) : null}

      {!noResults ? (
        <div id="convencional">
          <div className="vehicle-list-section-header">
            <Container>
              <Row>
                <Col>
                  <h2 className="vehicle-list-section-title text-center">
                    ¡Llevate tu vehículo en Montironi por <b>Venta Directa</b>!
                  </h2>
                </Col>
              </Row>
            </Container>
          </div>
          <Row className="d-flex pt-4">
            {filteredConvencional.length > 0 ? (
              filteredConvencional
                .sort((a, b) => a.convencional.prioridad - b.convencional.prioridad)
                .map((item, index) => (
                  <Col lg={4} md={6} xs={12} key={index} className="flex-wrap mb-4 d-flex">
                    <VehicleCard
                      info={item}
                      tipo={tipoSearch}
                      filtrados={filteredConvencional}
                      todosLosVehiculos={vehicles}
                    />
                  </Col>
                ))
            ) : (
              <p className="text-center pt-5 pb-5 w-100">Proximamente más opciones disponibles.</p>
            )}
          </Row>

          <div id="financiaciones" className="financing-section">
            {loadingFinanciaciones ? (
              <Row className="d-flex justify-content-center mb-5">
                <img src={loading} alt="Cargando..." style={{ width: 100, height: 100 }} />
              </Row>
            ) : financiaciones && financiaciones.length > 0 ? (
              <>
                <p className="financing-section-subtitle">Financiá por Venta Directa</p>
                <FinancingCarousel financiaciones={financiaciones} />
              </>
            ) : null}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default VehicleList;
